import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { App, ActionSheetController } from 'ionic-angular';
import { MenuProvider } from '@providers/menu/menu';
import { Observable } from 'rxjs/Observable';
import {
  HomePage,
  AchievementsPage,
  LeaderboardPage,
  LoginPage,
  ChagePasswordPage
} from '@pages';
import { AuthProvider } from '@providers/auth/auth';
import { CertificacionProvider } from '@providers/certificacion/certificacion';
import { VERSION, ASSETS } from '@env';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ImageViewerController } from 'ionic-img-viewer';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController } from 'ionic-angular';
import { LanguageProvider, LanguageEnum } from '@providers/language/language';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { Camera } from '@ionic-native/camera';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { AUTH } from '@env';
import { ModalAcercaDeComponent } from '../modal-acerca-de/modal-acerca-de';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Component({
  selector: 'menu',
  templateUrl: 'menu.html'
})
export class MenuComponent implements OnInit, AfterViewInit {

  isOpen: boolean;
  handleChangeMenu: Observable<boolean>;
  achievements = AchievementsPage;
  home = HomePage;
  leaderboard = LeaderboardPage;
  chagePasswordPage = ChagePasswordPage;
  certificado: any;
  PATH_LOGO: string;
  version = VERSION;
  jugador: Jugador = new Jugador;
  equipo: Equipo = new Equipo;
  _imageViewerCtrl: ImageViewerController;
  myAvatar: string;
  score: number = 0;
  avatar: any = {
    mime: '',
    avatar: '',
  };
  areasJugador: Array<any> = [];
  campaign: any;
  loader: any;
  avatarOriginal: any = {
    mime: '',
    avatar: '',
  };
  @ViewChild(ModalAcercaDeComponent) modalAcercaDe: ModalAcercaDeComponent;
  @ViewChild('header', { read: ElementRef }) header: ElementRef;
  primaryColor: string;

  constructor(
    private menuProvider: MenuProvider,
    private app: App,
    private authProvider: AuthProvider,
    private certificacionProvider: CertificacionProvider,
    public sanitizer: DomSanitizer,
    public imageViewerCtrl: ImageViewerController,
    public actionSheetCtrl: ActionSheetController,
    private translate: TranslateService,
    public loadingCtrl: LoadingController,
    private languageProvider: LanguageProvider,
    private campaignsProvider: CampaignsProvider,
    private camera: Camera,
    public transfer: FileTransfer,
    public colorProvider: ColorProvider,
    private events: Events
  ) {
    this.isOpen = false;
    this.PATH_LOGO = `${ASSETS.PATH_LOGO}`;
    this._imageViewerCtrl = imageViewerCtrl;
  }

  async ngOnInit() {
    this.handleChangeMenu = this.menuProvider.onChange();

    this.handleChangeMenu.subscribe( async isOpen => {
      this.isOpen = isOpen;

      if(this.isOpen) this.init()

      this.campaign = await this.campaignsProvider.get();
    });
    
  }

  async ngAfterViewInit() {
    this.updateColors();
    this.events.subscribe('color:updated', async () => {
      this.updateColors();
    });
  }

  async updateColors() {
    this.primaryColor = await this.colorProvider.getPrimaryColor();
    this.header.nativeElement.style.backgroundImage = await this.colorProvider.renderMenuBG();
  }

  async init() {
    this.jugador = await this.authProvider.getSession();
    
    if(!this.jugador) return ;

    this.equipo = await this.authProvider.getEquipo();
    this.score = await this.authProvider.getScorePersonal();

    this.avatar = await this.authProvider.getAvatar();
    this.myAvatar = `data:${this.avatar.mime};base64,${this.avatar.avatar}`;

    this.areasJugador = await this.authProvider.getAreasJugador(this.jugador._id);

    let response = await this.certificacionProvider.get(this.equipo.area.liderEntrenamiento);

    this.certificado = response;
  }

  showAvatar(avatar) {
    const imageViewer = this._imageViewerCtrl.create(avatar);
    imageViewer.present();
  }

  bypassSecurityTrustResourceUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  handleBody(txt) {
    return txt ? txt.split("\n").join("<br>"): '';
  }

  closeMenu() {
    this.menuProvider.setStatus(false);
  }

  goTo(page) {
    this.app.getRootNavs()[0].push(page);
    this.closeMenu();
  }

  async setArea() {
    this.areasJugador = await this.authProvider.getAreasJugador(this.jugador._id);

    let areas: any = this.areasJugador.map( e =>  {
      return {
        text: e.area.nombre,
        cssClass: e._id == this.equipo._id ? 'gameif-active-area': '',
        handler: () => {
          this._cambiaArea(e._id);
        }
      };
    });
    areas.push({
      text: this.translate.instant('perfil.cambiarArea.cancel'),
      role: 'cancel',
      cssClass: 'color-danger-as'
    });

    const actionSheet = this.actionSheetCtrl.create({
      // title: this.translate.instant('perfil.cambiarArea.areas'),
      buttons: areas,
      cssClass: 'gameif-action-sheet'
    });
    
    actionSheet.present({ animate: false }).then( x => {
      const actionSheetContainer: any = document.querySelector('.gameif-action-sheet .action-sheet-container');
      actionSheetContainer.style.opacity = '1';

      const actionSheetGroup: any = document.querySelectorAll('.gameif-action-sheet .action-sheet-group');
      actionSheetGroup.forEach(element => {
        element.style.background = this.primaryColor;  
      });
    });
  }

  private _cambiaArea(equipoId) {
    let equipo = this.areasJugador.find( e => e._id ==  equipoId);

    if( this.equipo._id != equipo._id ){
        this.equipo = equipo;
        this.authProvider.saveEquipo(equipo);

        const loader = this.loadingCtrl.create({
           content: "Please wait...",
        });
        loader.present();
        this.authProvider.changeArea(true);
        setTimeout( () => window.location.reload(true), 500);
    }
  }

  async cambiarIdioma() {
    const currentLanguage = this.translate.getDefaultLang();
    const es = await this.translate.instant(LanguageEnum.ES);
    const en = await this.translate.instant(LanguageEnum.EN);
    const pt = await this.translate.instant(LanguageEnum.PT);

    const idiomas = [
      {
        text: es,
        handler: () => {
          this._cambiarIdioma(LanguageEnum.ES)
        },
        cssClass: currentLanguage == 'es'? 'gameif-active-area': ''
      },
      {
        text: en,
        handler: () => {
          this._cambiarIdioma(LanguageEnum.EN)
        },
        cssClass: currentLanguage == 'en'? 'gameif-active-area': ''
      },
      {
        text: pt,
        handler: () => {
          this._cambiarIdioma(LanguageEnum.PT)
        },
        cssClass: currentLanguage == 'pt'? 'gameif-active-area': ''
      },
      {
        text: this.translate.instant('perfil.cambiarIdioma.cancel'),
        role: 'cancel'
      }
    ]

    const actionSheet = this.actionSheetCtrl.create({
      buttons: idiomas,
      cssClass: 'gameif-action-sheet'
    });
    actionSheet.present({ animate: false }).then( x => {
      const actionSheetContainer: any = document.querySelector('.gameif-action-sheet .action-sheet-container');
      actionSheetContainer.style.opacity = '1';

      const actionSheetGroup: any = document.querySelectorAll('.gameif-action-sheet .action-sheet-group');
      actionSheetGroup.forEach(element => {
        element.style.background = this.primaryColor;  
      });
    });
  }

  async _cambiarIdioma(lang) {
    this.translate.reloadLang(lang);
    this.languageProvider.set(lang);

    const loader = this.loadingCtrl.create({
       content: "Please wait...",
    });
    loader.present();
    setTimeout( () => window.location.reload(true), 500);
  }

  async logout() {
    await this.authProvider.cerrarSesion();
    await this.app.getRootNavs()[0].setRoot(LoginPage);
    this.closeMenu();
  }


  changeAvatar() {
    const actionSheet = this.actionSheetCtrl.create({
      // title: this.translate.instant('perfil.changeAvatar.title'),
      cssClass: 'gameif-action-sheet',
      buttons: [
        {
          text: this.translate.instant('perfil.changeAvatar.foto') ,
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          }
        },{
          text: this.translate.instant('perfil.changeAvatar.biblioteca'),
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },{
          text: this.translate.instant('perfil.changeAvatar.cancelar'),
          role: 'cancel'
        }
      ]
    });

    actionSheet.present({ animate: false }).then( x => {
      const actionSheetContainer: any = document.querySelector('.gameif-action-sheet .action-sheet-container');
      actionSheetContainer.style.opacity = '1';

      const actionSheetGroup: any = document.querySelectorAll('.gameif-action-sheet .action-sheet-group');
      actionSheetGroup.forEach(element => {
        element.style.background = this.primaryColor;  
      });
    });
  }

  async takePicture(source) {
    try {
      let imageURI = await this.camera.getPicture({
        sourceType: source,
        destinationType: this.camera.DestinationType.FILE_URI,
        correctOrientation: true,
        mediaType: this.camera.MediaType.PICTURE,
        encodingType: this.camera.EncodingType.JPEG
      });

      this.uploadFile(imageURI);
    } catch (error) {
      console.log('getlogo::', error);
    }
  }

  async uploadFile(imageURI) {
    let loader = this.loadingCtrl.create({
      content: "Actualizando ..."
    });
    loader.present();

    const fileTransfer: FileTransferObject = this.transfer.create();

    let options: FileUploadOptions = {
      fileKey: 'avatar',
      fileName: 'file.jpeg',
      chunkedMode: false,
      mimeType: "image/jpeg",
      headers: {}
    }

    try {
      await fileTransfer.upload(imageURI, `${AUTH.SET_AVATAR_V2}${this.jugador._id}`, options)
      
      let avatar = await this.authProvider.downloadAvatar(this.jugador._id);
      this.authProvider.saveAvatar(avatar);
      
      loader.dismiss();
    } catch (error) {
      console.log(error);
      loader.dismiss();
    }

  }

  showModalAcercaDe() {
    this.modalAcercaDe.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/menu/menu.ts